import { render } from "./App.vue?vue&type=template&id=71527568&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=71527568&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71527568"]])

export default __exports__